import React, { useMemo } from 'react';
import Header from './Header';
import $script from 'scriptjs';
import validUrl from 'valid-url';
import $ from 'jquery';
import winston from 'winston';
import robotoDataUri from './roboto';
import WaitText from './WaitText';
import * as bulmaToast from "bulma-toast";
import ReactCursorPosition from 'react-cursor-position';
import Footer from './Footer';
import * as _ from 'lodash';
import extractDomain from 'extract-domain';
import './Dashboard.scss';
import './Card.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faUpload, faMinusCircle, faUndo, faTimes, faInfoCircle, faArrowAltCircleUp } from '@fortawesome/free-solid-svg-icons';
import { Base64 } from 'js-base64';
import axios from 'axios';
import { User } from '@auth0/auth0-spa-js';
import {Elements, useElements, useStripe} from '@stripe/react-stripe-js';
import {loadStripe, Stripe, StripeElements} from '@stripe/stripe-js';
import {PaymentElement, ElementsConsumer} from '@stripe/react-stripe-js';
import config from './config';
import { urlToHttpOptions } from 'url';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(process.env.STRIPE_PUBLISHABLE_KEY as string);

interface CheckoutProps {
  clientSecret :string
  stripe :Stripe | null
  elements :StripeElements | null
}

interface CheckoutState {

}

class CheckoutForm extends React.Component<CheckoutProps, CheckoutState> {
  constructor(props :CheckoutProps) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {};
  }

  async handleSubmit(event) {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    const {stripe, elements} = this.props;

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const result = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: `${config.returnTo}?paymentComplete=true#dashboard`,
      },
    });

    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      console.log(result.error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  }

  render() {
    return <form className="checkout" onSubmit={this.handleSubmit}>
      <PaymentElement />
      <div style={{textAlign: 'right', margin: '1rem 0 1rem 0'}}><b>Due today (one-time setup fee): $5</b></div>
      <button className="button is-primary">Subscribe</button>
    </form>
  }
};

function Screenshot(props) {
  return <div className="pk-screenshot-container" onMouseDown={(e) => props.startHighlight(e, props.position)}
  onTouchStart={(e) => props.startHighlight(e, props.position)}
  onMouseUp={(e) => props.endHighlight(e, props.position)}
  onTouchEnd={(e) => props.endHighlight(e, props.position)}>
  <img width="100%" alt="screenshot" src={props.screenshot}/>
  { props.highlights.map((highlight, i) => <div key={`highlight-${i}`} style={{position: "absolute",
    backgroundColor: "rgba(255, 255, 0, 0.50)",
    top: `${highlight.start.y - 10}px`,
    left: `${highlight.start.x}px`,
    height: "20px",
    width: (highlight.end.x - highlight.start.x)}}></div>) }</div>
}

interface DashboardProps {
  newLink :string
  isAuthenticated :boolean
  getAuthTokenSilently :() => Promise<string>
  toast :(msg :string) => void
  showContact :() => void
  toSplash :() => void
  signUp :() => void
  user :User | undefined
  logout :() => void
}

type Link = {
  _id :string
  archive :boolean
  createdOn :string
  hits :number
  optimizeFor :SupportedPlatforms
  title :string
  description :string
  imgUrl :string
  destination :string
  linkCreated :string
  externalLink :string
}

type Point = {
  x :number
  y :number
}

type Highlight = {
  start :Point
  end :Point
}

enum SupportedPlatforms {
  FACEBOOK = "facebook",
  TWITTER = "twitter",
  REDDIT = "reddit"
}

enum TextTheme {
  BLUE = "blue",
  BLACK = "black",
  ORANGE = "orange",
  GREEN = "green",
  PURPLE = "purple"
}

enum SortBy {
  MOST_RECENT = "mostRecent",
  MOST_HITS = "mostHits"
}

enum PaymentType {
  ONE_TIME = "oneTime",
  SUBSCRIPTION = "subscription"
}

declare var paypal :any

interface DashboardState {
  newLink :string
  showCreateLink :boolean
  loading :boolean
  links: Link[]
  startIndex :number
  endIndex :number
  uploadedFile :string | ArrayBuffer | null
  highlighterOn :boolean
  highlights :Highlight[]
  highlighting :boolean
  editMode :EditMode
  textEditHtml :string
  selectingImage :boolean
  images :string[]
  screenshotFailed :boolean
  screenshot :string
  linkError :boolean
  isFetching :boolean
  customDomains :string[]
  domain :string
  failedFetch :boolean
  title :string
  description :string
  destination :string
  validationError :Element | null
  imagesFailed :boolean
  optimizeFor :SupportedPlatforms
  textTheme :TextTheme
  imageHeight :number
  type :string // from grabber, totally forget why this exists, seems to always be set to "website"
  metaSuccess :boolean
  showLogin :boolean
  newDomain :string
  invalidDomain :boolean
  domainContainsSlash :boolean
  addingDomain :boolean
  viewingArchive :boolean
  sortBy :SortBy
  isSubscribed :boolean
  subscriptionID :string
  paymentType :PaymentType
  subscribedOn :Date
  showDomains :boolean
  showSubscribe :boolean
  domains :string[]
  clientSecret : string | null
  customerID :string
  rootURL :string
  loadingImage :boolean
  creatingLink :boolean
}

enum EditMode {
  TEXT = "text",
  IMAGE = "image",
  SCREENSHOT = "screenshot"
}

const imageDict = {
  facebook: 628,
  twitter : 628,
  reddit: 1200,
}


class DashboardApp extends React.Component<DashboardProps, DashboardState> {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleLinkSubmit = this.handleLinkSubmit.bind(this);
    this.contentEditor = this.contentEditor.bind(this);
    this.textEditSvg = this.textEditSvg.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.startHighlight = this.startHighlight.bind(this);
    this.endHighlight = this.endHighlight.bind(this);
    this.highlighting = this.highlighting.bind(this);
    this.validateAndSubmit = this.validateAndSubmit.bind(this);
    this.handleLinkSubmit = this.handleLinkSubmit.bind(this);
    this.sendLinkData = this.sendLinkData.bind(this);
    this.handleCreateLink = this.handleCreateLink.bind(this);
    this.undoHighlight = this.undoHighlight.bind(this);
    this.refreshLinks = this.refreshLinks.bind(this);
    this.duplicate = this.duplicate.bind(this);
    this.toggleArchive = this.toggleArchive.bind(this);
    this.addDomain = this.addDomain.bind(this);
    this.removeDomain = this.removeDomain.bind(this);
    this.getDomains = this.getDomains.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.throttledScroll = _.throttle(this.handleScroll, 500);
    this.getLinkView = this.getLinkView.bind(this);
    this.selectPaymentType = this.selectPaymentType.bind(this);
    this.getSubscriptionStatus = this.getSubscriptionStatus.bind(this);
    this.showSubscribe = this.showSubscribe.bind(this);

    const sessionState = sessionStorage.getItem('state') && JSON.parse(sessionStorage.getItem('state')!);
    sessionStorage.removeItem('state');

    let clientSecret = sessionStorage.getItem("clientSecret")

    this.textEditHtml = '';

    this.state = sessionState || {
      newLink: this.props.newLink || '',
      title: '',
      description: '',
      editMode: EditMode.IMAGE,
      textTheme: 'blue',
      highlighterOn: false,
      highlights: [],
      selectingImage: false,
      customDomains: [],
      domains: [],
      domain: '',
      imageHeight: 628,
      optimizeFor: 'facebook',
      links: [],
      sortBy: 'mostRecent',
      newDomain: '',
      startIndex: 0,
      endIndex: 50,
      textEditHtml: '',
      paymentType: 'subscription',
      showSubscribe: false,
      loading: true,
      clientSecret,
      customerID: '',
      rootURL: '',
      loadingImage: false,
      creatingLink: false,
    };
  }

  throttledScroll :() => void;
  textEditHtml :string


  async componentDidMount() {
    $('#pk-text-edit').focus();

    let urlParams = new URLSearchParams(window.location.search);

    let justSubscribed = false;
    if(urlParams.get('paymentComplete')) {
      let clientSecret = urlParams.get('payment_intent_client_secret') as string;
      let stripe = await stripePromise;
      await stripe!.retrievePaymentIntent(clientSecret).then(({paymentIntent}) => {
        if(paymentIntent!.status === 'succeeded') {
          this.props.toast('Success! Thank you for subscribing.');
          justSubscribed = true;
        } else {
          this.props.toast('Payment was unsuccessful.');
        }
      });
    
      history.pushState({}, '', '/index.html#dashboard');
    }

    $(window).on('scroll', (e) => {
      this.throttledScroll();
    });

    this.getSubscriptionStatus();
    this.refreshLinks();
    this.getDomains();
    let rootURL = (await axios.get('/env')).data.ROOT_URL;
    this.setState({ rootURL });
    this.props.newLink && this.handleSubmit({ preventDefault: () => {}});

    const linkData = sessionStorage.getItem('linkData') && JSON.parse(sessionStorage.getItem('linkData')!);
    if(linkData && this.props.isAuthenticated) {
      if(this.state.isSubscribed || justSubscribed) {
        this.props.getAuthTokenSilently().then(async token => {
          await axios.post('/pro', linkData, {headers: {Authorization: `Bearer ${token}`}})
          this.setState({ showCreateLink: false }, () => {
            this.refreshLinks();
            this.props.toast('Link created!');
            sessionStorage.removeItem('linkData');
            try {
              window.gtag('event', 'linkCreated', {
                event_category: 'engagement',
                event_label: 'linkCreated'
              });
            } catch {}
          })
        });
      } else {
        this.showSubscribe();
      }
    }
  }

  refreshLinks() {
    if(this.props.isAuthenticated) {
      this.setState({ loading: true });
      this.props.getAuthTokenSilently().then(token => {
        fetch('/pro/list', {
          headers: {
            'Authorization': `Bearer ${token}`
          },
          cache: 'no-store',
        }).then(response => {
          if(response.ok) {
            response.json().then(data => {
              this.setState({ links: data.links, loading: false })
            });
          } else {
            this.setState({ links: [], loading: false });
          }
        })
      })
    } else {
      this.setState({ links: [], loading: false });
    }
  }

  showSubscribe() {
    try {
      window.gtag('event', 'showSubscribe', {
        event_category: 'engagement',
        event_label: 'showSubscribe'
      });
    } catch {}
    this.setState({ showSubscribe: true}, () => {
      if(!this.state.clientSecret) {
        this.props.getAuthTokenSilently().then(async token => {
          let res = await axios.get('/pro/payment-intent', {headers: {
            'Authorization': `Bearer ${token}`
          }});

          if(res.data.success) {
            sessionStorage.setItem("clientSecret", res.data.clientSecret);
            this.setState({ clientSecret: res.data.clientSecret});
          } else {
            window.location.href = '/pro/portal';
          }
        })
      }
    });
  }

  handleScroll() {
    const scrollTop = $(window).scrollTop();
    const docHeight = $(document).height();
    const winHeight = $(window).height();
    const scrollPercent = (scrollTop) / (docHeight - winHeight);
    let startIndex = this.state.startIndex;
    let endIndex = this.state.endIndex;
    let links = this.getLinkView();
    const pageIncrement = 50;
    const maxLinks = 100;
    if(scrollPercent > 0.9 && endIndex < links.length) {
      endIndex = Math.min(endIndex + pageIncrement, links.length);
    }

    if(scrollPercent < 0.1 && startIndex > 0) {
      startIndex = Math.max(startIndex - pageIncrement, 0);
    }

    if((endIndex - startIndex) > maxLinks) {
      const scrollTop = $(window).scrollTop();
      const docHeight = $(document).height();
      const winHeight = $(window).height();
      const scrollPercent = (scrollTop) / (docHeight - winHeight);

      if(scrollPercent < 0.2) {
        endIndex = this.state.startIndex + maxLinks;
      }

      if(scrollPercent > 0.8) {
        startIndex = endIndex - maxLinks;
      }
    }

    this.setState({ startIndex, endIndex });
  }


  handleFileUpload(e) {
    var reader = new FileReader();

    reader.addEventListener('load', () => {
      this.setState({ uploadedFile: reader.result });
    });

    reader.readAsDataURL(e.target.files[0]);
  }

  startHighlight(e, position) {
    if(this.state.highlighterOn) {
        e.preventDefault()
        const x = position.x;
        const y = position.y + document.querySelector('.pk-screenshot-container')!.scrollTop;
        const highlights = {...this.state.highlights};
        highlights.push({start: {x, y}, end: {x, y}} as Highlight);
        this.setState({ highlighting: true });
        this.setState({ highlights });
    }
  }

  highlighting(data) {
    if(this.state.highlighting) {
      const x = data.position.x;
      const y = data.position.y + document.querySelector('.pk-screenshot-container')!.scrollTop;
      const highlights = this.state.highlights;
      highlights[highlights.length - 1].end =  {x, y};
      this.setState({ highlights });
    }
  }

  endHighlight(e, position) {
    if(this.state.highlighterOn) {
        e.preventDefault()
        this.setState({highlighting: false});
    }
  }

  contentEditor() {
    switch(this.state.editMode) {
      case EditMode.IMAGE:
        if(this.state.uploadedFile) {
          return <div className="pk-image-container"><img src={this.state.uploadedFile as string} width="100%" alt="uploaded"/></div>
        } else if(this.state.loadingImage) {
          return <div className="pk-image-container"><img style={{paddingLeft: "25%"}} src="/img/spinner.gif" alt="spinner" /></div>
        } else {
          return <div><div className="pk-file-upload-container">
                <div className="pk-file-upload-content">
                 <div className="file">
                  <label className="file-label">
                    <input className="file-input" type="file" name="peek-image"
                        accept=".png,.jpg,.jpeg,image/png,image/jpeg"
                        onChange={this.handleFileUpload}/>
                    <span className="file-cta">
                      <span className="file-icon">
                        <FontAwesomeIcon icon={faUpload} />
                      </span>
                      <span className="file-label">
                        Choose a png or jpeg image…
                      </span>
                    </span></label></div>
                    <p>Or <a onClick={() => this.setState({selectingImage: true})}>
                      select an image from the website.</a></p></div></div>
                    <div className={`modal ${this.state.selectingImage && 'is-active'}`}>
                      <div className="modal-background" onClick={() => this.setState({selectingImage: false})}></div>
                      <div id="pk-image-modal" className="modal-content">
                      <div className="box">
                        {(() => {
                          if(this.state.images) {
                            return this.state.images.length > 0 ? this.state.images.map((src, i) => <div className="pk-select-image-from-site" key={`img-${i}`}>
                              <img id={`src-img-${i}`} src={src} alt={`source ${i}`}/>
                              <button className="button is-large" onClick={() => this.setState({uploadedFile: src, selectingImage: false})}>
                              Select</button></div>) : "We didn't find any images on this page.";
                            } else {
                              return <div><center>Loading images from the site...</center>
                              <img src="/img/spinner.gif" alt="spinner" /></div>
                            }})()}
                      </div></div>
                      <button className="modal-close is-large" aria-label="close" onClick={() => this.setState({selectingImage: false})}></button>
                    </div></div>

          }
      case EditMode.TEXT:
        return <div className="pk-text-edit-container" dangerouslySetInnerHTML={ {__html: this.textEditSvg(this.state.textEditHtml)} }></div>;
      case EditMode.SCREENSHOT:
        if(!this.state.screenshotFailed) {
          if(this.state.screenshot) {
              return <ReactCursorPosition style={{ cursor: this.state.highlighterOn ? "text" : "default" }}
              onPositionChanged={this.highlighting}>
              <Screenshot screenshot={this.state.screenshot}
              startHighlight={this.startHighlight}
              endHighlight={this.endHighlight}
              highlights={this.state.highlights}/></ReactCursorPosition>;
            } else {
              return <div className="pk-screenshot-loading"><WaitText /><img src="/img/spinner.gif" alt="spinner" /></div>
            }
        } else {
          return <div className="pk-screenshot-loading">
          <div className="pk-failed"><FontAwesomeIcon icon={faExclamationTriangle} /> There was a problem fetching your screenshot.
          You can try again or <a onClick={this.props.showContact}>report the issue</a>.</div></div>
        }
      default:
        winston.log('error', 'Edit mode not found');
    }
  }

  componentDidUpdate() {
    $('#pk-text-edit').keyup((e) => {
      this.textEditHtml = ($('#pk-text-edit') && $('#pk-text-edit').html()) || '' ;
    })
  }

  handleSubmit(e) {
    e.preventDefault();
    if(validUrl.isHttpUri(this.state.newLink) || validUrl.isHttpsUri(this.state.newLink)) {
      this.setState({linkError: false}, () => {
        this.handleLinkSubmit();
      });
    } else {
      this.setState({linkError: true})
    }
  }

  handleLinkSubmit() {
    type MetaResponse = {
      success :boolean
      destination :string
      title :string
      description :string
      imageUrls? :string[]
    }

    this.setState({isFetching: true}, async () => {
      let metaResponse ;
      let res;
      try {
        res = await axios.post('/grab/meta', {url: this.state.newLink});
      } catch(err) {
        this.setState({ failedFetch: true, isFetching: false }, () => {
          window.gtag('event', 'exception', {
              description: `Failed fetch for ${this.state.newLink}`,
              fatal: false
          });
        })
        return;
      }

      metaResponse = res.data as MetaResponse;
      
      if(metaResponse.success) {
        let domains = _.clone(this.state.customDomains);
        domains.unshift(metaResponse.destination);
        this.textEditHtml = '';
        this.setState({isFetching: false,
          failedFetch: false,
          showCreateLink: true,
          creatingLink: false,
          title: metaResponse.title,
          editMode: EditMode.IMAGE,
          description: metaResponse.description,
          destination: metaResponse.destination,
          validationError: null,
          screenshotFailed: false,
          domains,
          domain: domains[0],
          textTheme: TextTheme.BLUE,
          type: res.data.type,
          loadingImage: true,
          metaSuccess: metaResponse.success}, async () => {
            if(metaResponse.imageUrls && metaResponse.imageUrls.length) {
              let res = await axios.post('/grab/images', {imageUrls: metaResponse.imageUrls, url: this.state.newLink});

              if(res.data.success) {
                let uploadedFile = null;
                if(res.data.images.length > 0) {
                  uploadedFile = res.data.images[0];
                }
                this.setState({ images: res.data.images, imagesFailed: false, uploadedFile, loadingImage: false });
              } else {
                this.setState({ imagesFailed: true, loadingImage: false })
              }
            } else {
              this.setState({ images: [], loadingImage: false });
            }

            let res = await axios.post('/grab/screenshot', {url: this.state.newLink});

            if(res.data.success) {
              this.setState({ screenshot: res.data.screenshot, screenshotFailed: false });
            } else {
              this.setState({ screenshotFailed: true })
            }
        });
      } else {
        this.setState({ failedFetch: true, isFetching: false }, () => {
          try {
            window.gtag('event', 'exception', {
              description: `Failed fetch for ${this.state.newLink}`,
              fatal: false
            });
          } catch(err) { console.log(err) }
        });
      }
    });      
  }

  textEditSvg(innerHtml) {
    let height = Math.ceil(400 * (imageDict[this.state.optimizeFor] / 1200));
    let divStyle = '';
    divStyle += `width: 400px; height: ${height}px; color: #fafafa;`
    divStyle += "font-family: 'Roboto500', sans-serif;"
    divStyle += `padding: 10px; font-size: 25px;`
    divStyle += "text-align: center;"
    divStyle += '--webkit-user-modify: read-write-plaintext-only;'
    divStyle += "word-wrap: break-word;";
    divStyle += `align-items: center;
                 display: flex;
                 justify-content: center;`
    divStyle += 'line-height: 1.2; box-sizing: border-box;'

    switch(this.state.textTheme) {
      case 'blue':
        divStyle += 'background: linear-gradient(to right, #396afc , #2948ff);';
        break;
      case 'black':
        divStyle += 'background: linear-gradient(to right, #000000, #434343);';
        break;
      case 'orange':
        divStyle += 'background: linear-gradient(to right, #ee0979, #ff6a00);';
        break;
      case 'green':
        divStyle += 'background: linear-gradient(to right, #67B26F, #4ca2cd);';
        break;
      case 'purple':
        divStyle += 'background: linear-gradient(to right, #ff00cc, #333399);';
        break;
      default:
        winston.log('error', 'Theme not found.');
    }

    return `<svg xmlns="http://www.w3.org/2000/svg" id="pk-text-svg" viewBox="0 0 400 ${height}">
              <foreignObject width="100%" height="100%">
              <style type="text/css">
                  @font-face {
                                font-family: 'Roboto500';
                                font-style: normal;
                                font-weight: 500;
                                src: local('Roboto Medium'), local('Roboto-Medium'), url("${robotoDataUri}") format('woff2');
                                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
                              };
              </style>
              <div style="${divStyle}"xmlns="http://www.w3.org/1999/xhtml"><div id="pk-text-edit"
              contentEditable="true" placeholder="Write your caption...">${this.textEditHtml || innerHtml}</div></div></foreignObject></svg>`
  }

  validateAndSubmit(e) {
    e.preventDefault();
    this.setState({creatingLink: true})
    let validationError;
    if(this.state.editMode === 'image' && !this.state.uploadedFile) {
      validationError = <div className="pk-validation-error"><FontAwesomeIcon icon={faExclamationTriangle} /> Please upload your image.</div>;
    }

    if(this.state.editMode ==='text' && !$('#pk-text-edit').text()) {
      validationError = <div className="pk-validation-error"><FontAwesomeIcon icon={faExclamationTriangle} /> Please enter your caption.</div>
    }

    if(!validationError) {
      this.handleCreateLink();
    }
    this.setState({validationError});
  }

  undoHighlight(e) {
    e.preventDefault();
    var highlights = _.clone(this.state.highlights);
    highlights.pop();
    this.setState({ highlights });
  }

  async sendLinkData(base_image :CanvasImageSource, yPos :number, sWidth :number, sHeight :number, highlights :Highlight[] | null, highlightClientTop :number | null) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d') as CanvasRenderingContext2D;
    canvas.width = 1200;
    canvas.height = this.state.imageHeight;
    const aspectRatio = this.state.imageHeight / 1200;
    context.drawImage(base_image, 0, yPos, sWidth, sHeight, 0, 0, 1200, this.state.imageHeight);

    if(highlights) {
      highlights.forEach(highlight => {
        const width = 60;
        if(highlight.start.y > (highlightClientTop! - aspectRatio * width)
          || highlight.start.y < (highlightClientTop! + this.state.imageHeight + aspectRatio * width)) {
          context.fillStyle = '#ffff0080';
          context.fillRect(highlight.start.x, highlight.start.y - (30 + highlightClientTop!),
              highlight.end.x - highlight.start.x, width);
        }
      });
    }
    const image = canvas.toDataURL('image/jpeg', 0.98);
    const linkData = { externalLink: this.state.newLink,
      title: this.state.title,
      description: this.state.description,
      destination: this.state.domain,
      type: this.state.type,
      imageHeight: this.state.imageHeight,
      optimizeFor: this.state.optimizeFor,
      version: 2,
      image }

    if(this.props.isAuthenticated) {
      if(this.state.isSubscribed) {
        let token = await this.props.getAuthTokenSilently();
        await axios.post('/pro', linkData, {headers: {Authorization: `Bearer ${token}`}});
        this.setState({ showCreateLink: false, creatingLink: false}, () => {
          this.refreshLinks();
          this.props.toast('Link created!');
  
          try {
            window.gtag('event', 'linkCreated', {
              event_category: 'engagement',
              event_label: 'linkCreated'
            });
          } catch {}
        })
      } else {
        sessionStorage.setItem('linkData', JSON.stringify(linkData));
        this.showSubscribe();
      }
    } else {
      sessionStorage.setItem('linkData', JSON.stringify(linkData));
      this.setState({ showLogin: true })
    }
  }

  handleCreateLink() {
    var base_image;
    var yPos, sWidth, sHeight, scale;
    let aspectRatio = this.state.imageHeight / 1200;
    switch(this.state.editMode) {
        case 'image':
            base_image = document.querySelector('.pk-create-link .pk-image-container img');
            sWidth = (document.querySelector('.pk-create-link .pk-image-container img') as HTMLImageElement).naturalWidth;
            sHeight = Math.floor(sWidth * aspectRatio);
            scale = sWidth / document.querySelector('.pk-create-link .pk-image-container')!.clientWidth;
            yPos = Math.floor(document.querySelector('.pk-create-link .pk-image-container')!.scrollTop * scale);
            this.sendLinkData(base_image, yPos, sWidth, sHeight, null, null);
            break;
        case 'text':
          base_image = new Image(1200, this.state.imageHeight);
          const svgText = new XMLSerializer().serializeToString(document.querySelector('#pk-text-svg')!)
          var imgData = 'data:image/svg+xml;base64,' + Base64.encode(svgText);
          base_image.src = imgData;
          yPos = 0;
          sWidth = 1200
          sHeight = this.state.imageHeight
          base_image.onload = (e) => {
            this.sendLinkData(base_image, yPos, sWidth, sHeight, null, null);
          }
          break;
        case 'screenshot':
            base_image = document.querySelector('.pk-screenshot-container img');
            sWidth = (document.querySelector('.pk-screenshot-container img') as HTMLImageElement).naturalWidth;
            const clientTop = document.querySelector('.pk-screenshot-container')!.scrollTop;
            const clientWidth = document.querySelector('.pk-screenshot-container')!.clientWidth;
            sHeight = Math.floor(sWidth * aspectRatio);
            scale = sWidth / clientWidth;
            yPos = Math.floor(clientTop * scale);
            const highlightScale = 1200 / clientWidth;
            const highlightClientTop = clientTop * highlightScale;
            const highlights = this.state.highlights
                .map(h => ({start: {x: (highlightScale * h.start.x), y: (highlightScale * h.start.y)},
                end: {x: highlightScale * h.end.x, y: highlightScale * h.end.y}}))
            this.sendLinkData(base_image, yPos, sWidth, sHeight, highlights, highlightClientTop);
            break;
        default:
            winston.log('error', 'Bad Edit Mode');
    }
  }

  copyLink(link) {
    var range = document.createRange();
    range.selectNode(document.querySelector(`a[href='${link.linkCreated}']`)!);
    window.getSelection()!.removeAllRanges();
    window.getSelection()!.addRange(range);
    document.execCommand("copy");
    window.getSelection()!.removeAllRanges();
    this.props.toast('Link copied to clipboard!');
  }

  duplicate(link) {
    console.log(link);
    const img = new Image();
    img.src = link.imgUrl;

    let domains = _.clone(this.state.customDomains);
    domains.unshift(`${extractDomain(link.externalLink).split('.')[0]}.peek.link`);
    domains = domains.filter(d => d !== link.destination);
    domains.unshift(link.destination);

    img.onload = (e) => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx!.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL("image/jpeg");

      this.textEditHtml = '';
      this.setState({
        editMode: EditMode.IMAGE,
        title: link.title,
        description: link.description,
        domain: link.destination,
        //domains,
        uploadedFile: dataURL,
        optimizeFor: link.optimizeFor,
        imageHeight: link.imageHeight,
        newLink: link.externalLink,
        validationError: null,
        screenshotFailed: false,
        showCreateLink: true,
        creatingLink: false,
        metaSuccess: true,
        textTheme: TextTheme.BLUE,
        loadingImage :true,
      }, async () => {
        let res = await axios.post('/grab/meta', {url: this.state.newLink});

        if(res.data.success) {
          if(res.data.imageUrls && res.data.imageUrls.length) {
            res = await axios.post('/grab/images', {imageUrls: res.data.imageUrls, url: this.state.newLink});
            if(res.data.success) {
              let uploadedFile = null;
              if(res.data.images.length > 0) {
                uploadedFile = res.data.images[0];
              }
              this.setState({ images: res.data.images, imagesFailed: false, uploadedFile, loadingImage: false });
            } else {
              this.setState({ imagesFailed: true, loadingImage: false })
            }

          }
        } else {
          this.setState({ images : [], loadingImage: false });
        }

        res = await axios.post('/grab/screenshot', {url: this.state.newLink});

        if (res.data.success) {
          this.setState({ screenshot: res.data.screenshot, screenshotFailed: false });
        } else {
          this.setState({ screenshotFailed: true })
        }
      })
    }
  }

  toggleArchive(link) {
    const links = [] as Link[];
    const archive = !link.archive;
    this.state.links.forEach(l => {
      if(l._id === link._id) {
        l.archive = archive;
      }
      links.push(l);
    })

    this.setState({ links }, () => {
      this.props.toast(archive ? 'Link archived!' : 'Link unarchived!');
      this.props.isAuthenticated && this.props.getAuthTokenSilently().then(token => {
        fetch(`/pro/set-archive?_id=${link._id}&archive=${archive}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          },
          cache: 'no-store',
        })
      })
    });
  }

  addDomain(e) {
    e.preventDefault();
    const invalidDomain = !(/^[a-zA-Z0-9\-]+\.[a-zA-Z0-9\-]+\.([a-zA-Z0-9\-]+)\.?([a-zA-Z0-9\-]+)?$/.test(this.state.newDomain));
    const domainContainsSlash = this.state.newDomain.indexOf('/') >= 0;
    this.setState({ invalidDomain: false, domainContainsSlash: false })
    if(invalidDomain || domainContainsSlash) {
      this.setState({ invalidDomain, domainContainsSlash });
    } else {
      this.setState({ addingDomain: true }, () => {
        this.props.isAuthenticated && this.props.getAuthTokenSilently().then(token => {
          fetch(`/pro/add-domain?domain=${this.state.newDomain}`, {
            headers: {
              'Authorization': `Bearer ${token}`
            },
            cache: 'no-store',
          }).then(response => {
            this.setState({ addingDomain: false }, this.getDomains);
          })
        });
      })
    }
  }

  removeDomain(domain) {
    let customDomains = _.clone(this.state.customDomains);
    customDomains = customDomains.filter(d => d !== domain);

    this.setState({ customDomains });

    this.props.isAuthenticated && this.props.getAuthTokenSilently().then(token => {
      fetch(`/pro/remove-domain?domain=${domain}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        cache: 'no-store',
      }).then(response => {
        this.getDomains();
      })
    });
  }

  getDomains() {
    this.props.isAuthenticated && this.props.getAuthTokenSilently().then(token => {
      fetch('/pro/list-domains', {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        cache: 'no-store',
      }).then(response => {
        response.json().then(result => {
          this.setState({ customDomains: result.customDomains });
        });
      })
    });
  }

  getLinkView() {
    return this.state.links.filter(l => this.state.viewingArchive ? l.archive : !l.archive)
      .sort((linkA, linkB) => {
        switch(this.state.sortBy) {
          case SortBy.MOST_RECENT:
            return new Date(linkB.createdOn).valueOf() - new Date(linkA.createdOn).valueOf();
          case SortBy.MOST_HITS:
            return linkB.hits - linkA.hits;
        }
      });
  }

  getSubscriptionStatus() {
    this.props.isAuthenticated && this.props.getAuthTokenSilently().then(token => {
      fetch('/pro/is-subscribed', {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        cache: 'no-store',
      }).then(response => {
        response.json().then(result => {
          this.setState({ isSubscribed: result.isSubscribed, subscriptionID: result.subscriptionID, subscribedOn: result.subscribedOn, customerID: result.customerID })
        })
      })
    });
  }

  selectPaymentType(e) {
    this.setState({ paymentType: e.target.value }, () => {
        if(this.state.paymentType === PaymentType.ONE_TIME) {
          const onApproveOneTime = (data, actions) => {
              this.props.isAuthenticated && this.props.getAuthTokenSilently().then(token => {
                  actions.order.capture().then(() => {
                  fetch(`/pro/subscribe?orderID=${data.orderID}`, {
                    headers: {
                      'Authorization': `Bearer ${token}`
                    },
                    cache: 'no-store',
                  }).then(() => {
                    try {
                    window.gtag('event', 'purchase', {
                        "transaction_id": data.orderID,
                        "event_label": 'oneTime',
                        "value": 9.99,
                        "currency": "USD",
                        "items": [
                          {
                            "id": 'pro_oneTime',
                            "name": "pro_oneTime",
                            "list_name": "Peeklink Pro Pay as You Go",
                            "quantity": 1,
                            "price": '9.99'
                          }
                        ]
                      });
                  } catch {}
                    this.getSubscriptionStatus();
                  });
              })
            })
          }

          $script('https://www.paypal.com/sdk/js?client-id=Aa0CqMV9pfZSnf3D3aMFUPYEq8flnTkBQjhfmRvLXYMyCBUxG3_bwBbhETZSvzlZJgWxgFeYGK6324xO&intent=capture', () => {
            paypal.Buttons({
            createOrder: function(data, actions) {
              // This function sets up the details of the transaction, including the amount and line item details.
              return actions.order.create({
                intent: 'CAPTURE',
                purchase_units: [{
                  amount: {
                    currency_code: 'USD',
                    value: '9.99',
                  },
                  description: 'Peeklink Pro 7 days',
                  soft_descriptor: 'Peeklink',
                }],
                application_context :  {
                   shipping_preference: "NO_SHIPPING"
                }
              });
            },
            onApprove: onApproveOneTime,
          }).render('#pk-paypal-one-time');
          })
        }

        if(this.state.paymentType === 'subscription') {
          const onApproveSubscription = (data, actions) => {
              this.props.isAuthenticated && this.props.getAuthTokenSilently().then(token => {
              fetch(`/pro/subscribe?subscriptionID=${data.subscriptionID}`, {
                headers: {
                  'Authorization': `Bearer ${token}`
                },
                cache: 'no-store',
              }).then(() => {

                try {
                window.gtag('event', 'purchase', {
                    "transaction_id": data.subscriptionID,
                    "event_label": 'subscription',
                    "value": 20.00,
                    "currency": "USD",
                    "items": [
                      {
                        "id": 'pro_subscription',
                        "name": "pro_subscription",
                        "list_name": "Peeklink Pro",
                        "quantity": 1,
                        "price": '20.00'
                      }
                    ]
                  });
              } catch {}
                this.getSubscriptionStatus();
              });
            })
            }

          $script('https://www.paypal.com/sdk/js?client-id=Aa0CqMV9pfZSnf3D3aMFUPYEq8flnTkBQjhfmRvLXYMyCBUxG3_bwBbhETZSvzlZJgWxgFeYGK6324xO&vault=true', () => {
            paypal.Buttons({
              createSubscription: function(data, actions) {
                return actions.subscription.create({
                  plan_id: 'P-4KH35782U61432738LY3DRYI',
                  application_context :  {
                     shipping_preference: "NO_SHIPPING"
                  }
                });
              },
              onApprove: onApproveSubscription }).render('#pk-paypal');
        });
      }
    });
  }

  render() {
    return <div><div className="pk-dashboard">
      <Header showDomains={() => this.setState({ showDomains: true })}
        isSubscribed={this.state.isSubscribed} subscriptionID={this.state.subscriptionID}
        showContact={this.props.showContact} getSubscriptionStatus={this.getSubscriptionStatus}
        subscribedOn={this.state.subscribedOn} toast={this.props.toast}
        signUp={this.props.signUp}
        user={this.props.user}
        logout={this.props.logout}
        isAuthenticated={this.props.isAuthenticated}
        showSubscribe={this.showSubscribe} toSplash={this.props.toSplash}
        customerID={this.state.customerID} />
      <form onSubmit={this.handleSubmit} className="pk-pro-paste-link"><div className="field has-addons">
        <div className={`pk-pro-paste-input control ${this.state.isFetching && 'is-loading'}`}>
          <input className="input" type="text" placeholder="Paste your link..." value={this.state.newLink} onChange={e => this.setState({ newLink: e.target.value })}/>
        </div>
        <div className="control">
          <input type="submit" value="Edit preview" className="button is-primary" />
        </div>
      </div>
      </form>
      <center>{this.state.linkError && <p><FontAwesomeIcon icon={faExclamationTriangle} /> Please enter a valid URL.</p>}
      {this.state.failedFetch && <p><FontAwesomeIcon icon={faExclamationTriangle} />
          &nbsp;Failed to fetch URL. <a href={this.state.newLink} target="_blank">Try for yourself</a>
        &nbsp;or <a onClick={this.props.showContact}>report</a> the issue.</p>}</center>

      <div className="pk-link-list">
        <div className="pk-view-options level">
          <div className="level-left">{this.state.viewingArchive ? <h3 className="title is-3">Archive</h3> : undefined}</div>
          <div className="level-right">
            <button className="button is-text" onClick={() => this.setState({ viewingArchive: !this.state.viewingArchive })}>
            {this.state.viewingArchive ? 'View links' : 'View archive'}</button>
            <div className="select">
              <select value={this.state.sortBy} onChange={(e) => this.setState({ sortBy: e.target.value as SortBy })}>
                <option value={SortBy.MOST_RECENT}>Most recent</option>
                <option value={SortBy.MOST_HITS}>Most clicks</option>
              </select>
            </div>
          </div>
        </div>
      {!this.state.loading && this.getLinkView().slice(this.state.startIndex, this.state.endIndex).map(link =>
        <div key={link._id} className="pk-link-list-card columns">
          <div className="column pk-select-container">
          <div className="pk-card">
              <div className={`pk-editor ${link.optimizeFor}`}>
              <div className="pk-image-container"><img src={link.imgUrl} /></div></div>
              <div className="pk-content">
              <p className="pk-card-title">{link.title}</p>
              <p className="pk-description">{link.description}</p>
              <p className="pk-destination">{link.destination}</p>
              </div>
              </div>
          </div>
          <div className="column">
          <div className="content">
          <table>
            <tbody>
              <tr>
                <td><b>Link</b></td>
                <td><a href={link.linkCreated} target="_blank">{link.linkCreated}</a></td>
              </tr>
              <tr>
                <td><b>Target</b></td>
                <td><a href={link.externalLink} target="_blank">{link.externalLink}</a></td>
              </tr>
              <tr>
                <td><b>For</b></td>
                <td>{link.optimizeFor}</td>
              </tr>
              <tr>
                <td><b>Created</b></td>
                <td>{(new Date(link.createdOn)).toLocaleString()}</td>
              </tr>
              <tr>
                <td><b>Clicks</b></td>
                <td>{link.hits}</td>
              </tr>
            </tbody>
          </table></div>
          <div className="buttons has-addons">
            <button className="button" onClick={() => this.copyLink(link)}>Copy link</button>
            <button className="button" onClick={() => this.duplicate(link)}>Duplicate</button>
            <button className="button" onClick={() => this.toggleArchive(link)}>{this.state.viewingArchive ? 'Unarchive' : 'Archive'}</button>
          </div>
          </div>
        </div>)}
    {!this.state.loading && !this.getLinkView().length && (this.state.viewingArchive ? <center><h3><em>No archived links</em></h3></center>
      : <center>
      <h2 className="title is-2">Welcome to Peeklink!</h2>
      <h5 className="subtitle is-5"><em>Create a new link above to get started</em></h5></center>)}

    {this.state.loading && <div className="pk-loader">Loading...</div>}
    </div>
      {this.state.showCreateLink && <div className="pk-create-link modal is-active">
        <div className="modal-background" onClick={() => this.setState({ showCreateLink: false })}></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Edit link preview</p>
            <button className="delete" aria-label="close" onClick={() => this.setState({ showCreateLink: false })}></button>
          </header>
          <div className="pk-url-bar"><em>{this.state.newLink}</em></div>
          <section className="modal-card-body">
            <div className="columns">
            <div className="column">
            <div className="pk-question">
            <div className="field-label is-normal">
                <label className="label">Optimize size for</label>
              </div>
              <div className="field-body">
                <div className="field">
                  <div className="control">
                  <div className="select">
                    <select onChange={(e) => this.setState({ optimizeFor: e.target.value as SupportedPlatforms, imageHeight: imageDict[e.target.value] })} value={this.state.optimizeFor}>
                      <option value={SupportedPlatforms.FACEBOOK}>Facebook, Instagram, LinkedIn, Twitter (1.91:1)</option>
                      <option value={SupportedPlatforms.REDDIT}>Reddit (1:1)</option>
                    </select>
                  </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="pk-question">
            <div className="field-label is-normal">
                <label className="label">Link title</label>
              </div>
              <div className="field-body">
                <div className="field">
                  <div className="control">
                    <input className="input" type="text"
                    placeholder="Your link title..."
                    value={this.state.title} onChange={(e) => this.setState({ title: e.target.value })} />
                  </div>
                </div>
              </div>
            </div>

            <div className="pk-question">
            <div className="field-label is-normal">
                <label className="label">Link description</label>
              </div>
              <div className="field-body">
                <div className="field">
                  <div className="control">
                    <textarea className="textarea" rows={3} placeholder="Describe your content..."
                    onChange={e => this.setState({ description: e.target.value })} value={this.state.description}></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div className="pk-question">
            <div className="field-label is-normal">
                <label className="label">Select domain</label>
              </div>
              <div className="field-body">
                <div className="field">
                  <div className="control">
                  <div className="select">
                    <select onChange={(e) => this.setState({ domain: e.target.value })} value={this.state.domain}>
                      {this.state.domains.map(domain => <option key={domain} value={domain}>{domain}</option>)}
                    </select>
                  </div>
                  </div>
                </div>
              </div>
            </div>
            </div>

            <div className="column">

            <div className="container pk-question">
                <div className="field-label is-normal">
                    <label className="label">Select your image</label>
                </div>
                <div className="columns">
                    <div className="column pk-select-container">
                    <div className="level">
                      <div className="level-left">
                      <div className="tabs is-toggle is-toggle-rounded">
                          <ul>
                            <li className={this.state.editMode === 'image' ? "is-active" : ''}>
                              <a onClick={() => this.setState({ editMode: EditMode.IMAGE })}>
                                Image
                              </a>
                            </li>
                            <li className={this.state.editMode === 'text' ? "is-active" : ''}>
                              <a onClick={() => this.setState({ editMode: EditMode.TEXT})}>
                                Caption
                              </a>
                            </li>
                            <li className={this.state.editMode === 'screenshot' ? "is-active" : ''}>
                              <a onClick={() => this.setState({ editMode: EditMode.SCREENSHOT })}>
                                Screenshot
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    <div className="level-right">

                    {this.state.editMode === EditMode.TEXT && <span>
                        <a className={"pk-theme blue " + (this.state.textTheme === 'blue' && 'is-active')}
                          onClick={() => {this.setState({textTheme: TextTheme.BLUE})}}>&nbsp;</a>
                        <a  className={"pk-theme black " + (this.state.textTheme === 'black' && 'is-active')}
                         onClick={() => {this.setState({textTheme: TextTheme.BLACK})}}>&nbsp;</a>
                        <a  className={"pk-theme orange " + (this.state.textTheme === 'orange' && 'is-active')}
                        onClick={() => {this.setState({textTheme: TextTheme.ORANGE})}}>&nbsp;</a>
                        <a  className={"pk-theme green " + (this.state.textTheme === 'green' && 'is-active')}
                       onClick={() => {this.setState({textTheme: TextTheme.GREEN})}}>&nbsp;</a>
                        <a  className={"pk-theme purple " + (this.state.textTheme === 'purple' && 'is-active')}
                        onClick={() => {this.setState({textTheme: TextTheme.PURPLE})}}>&nbsp;</a>
                         </span> }

                     {this.state.editMode === EditMode.IMAGE && this.state.uploadedFile && <span className="button" title="Select a new image"
                        onClick={() => this.setState({uploadedFile: ''})}>
                       <FontAwesomeIcon icon={faArrowAltCircleUp} /></span>}

                      {this.state.editMode === EditMode.SCREENSHOT && <div className="buttons has-addons">
                        {this.state.highlights.length > 0 && <span className="button" title="undo" onClick={this.undoHighlight}>
                        <FontAwesomeIcon icon={faUndo} /></span>}
                        <span onClick={() => this.setState({highlighterOn: !this.state.highlighterOn })}
                        className={`button ${this.state.highlighterOn && 'is-selected'}`} title="highlighter">
                        <img src="/img/highlighter.png" alt="highlighter" /></span>
                      </div> }

                    </div></div>
                      {this.state.metaSuccess ? <div className="pk-card">
                          <div className={`pk-editor ${this.state.optimizeFor}`}>{this.contentEditor()}</div>
                          <div className="pk-content">
                          <p className="pk-card-title">{this.state.title}</p>
                          <p className="pk-description">{this.state.description}</p>
                          <p className="pk-destination">{this.state.domain}</p></div></div>
                            : <div><img src="/img/spinner.gif" alt="spinner" /></div>}
                    </div></div></div>
              </div></div>
          </section>
          <footer className="modal-card-foot"><>
            <button className="button is-text" onClick={() => this.setState({ showCreateLink: false })}>Cancel</button>
            <button className={`button is-primary ${this.state.creatingLink && 'is-loading'}`} onClick={this.validateAndSubmit}>Create link</button>
            {this.state.validationError}
            </>
          </footer>
        </div>
      </div>}
      {this.state.showSubscribe && <div className="pk-subscribe modal is-active">
          <div className="modal-background" onClick={() => this.setState({showSubscribe: false})}></div>
          {this.state.isSubscribed &&
            <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title">Thank you!</p>
              <button className="delete" aria-label="close" onClick={() => this.setState({showSubscribe: false})}></button>
            </header>
            <section className="modal-card-body content">
              <ul>
                <li>You now have full access to Peeklink</li>
                <li>You can create unlimited links with unlimited traffic</li>
                <li>If you have have questions or comments, feel free to <a onClick={this.props.showContact}>reach out</a></li>
              </ul>
              <center><img src="/img/logo2.png" /></center>
            </section>
            </div>}
        
        {!this.state.isSubscribed && <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">Almost there!</p>
          <button className="delete" aria-label="close" onClick={() => this.setState({showSubscribe: false})}></button>
        </header>
          <section className="modal-card-body content">
            <p>The best of Peeklink, for everyone.</p>
            <ul>
              <li>Pay only for what you use</li>
              <li>$1 per 1,000 clicks, billed monthly</li>
              <li>Free after 100,000 clicks (max charge $100 / month)</li>
              <li>Payment helps reduce spam and fraud</li>
            </ul>
            
          {this.state.clientSecret ? <Elements stripe={stripePromise} options={{clientSecret: this.state.clientSecret}}><ElementsConsumer>
      {({stripe, elements}) => 
        (<CheckoutForm clientSecret={this.state.clientSecret as string} stripe={stripe} elements={elements} />)}</ElementsConsumer></Elements> : <div style={{ textAlign: "center" }}>
            <img src="/img/spinner.gif" alt="spinner" /></div>}
        </section>
        </div>}
      </div>}

      <div className={`pk-domains modal ${this.state.showDomains && 'is-active'}`}>
      <div className="modal-background" onClick={() => this.setState({ showDomains: false })}></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">Custom domains</p>
          <button className="delete" aria-label="close" onClick={() => this.setState({ showDomains: false })}></button>
        </header>
        <section className="modal-card-body">
          <form onSubmit={this.addDomain}>
          <div className="field has-addons">
            <div className={`control ${this.state.addingDomain && 'is-loading'}`}>
              <input className="input" type="text" placeholder="e.g., links.myblog.com" value={this.state.newDomain}
              onChange={e => this.setState({ newDomain: e.target.value })} />
            </div>
            <div className="control">
              <input type="submit" value="Add domain" className="button is-primary" />
            </div>
          </div>
          {this.state.invalidDomain && <center><FontAwesomeIcon icon={faExclamationTriangle} />&nbsp;&nbsp;Please use the format <code>subdomain.domain.tld</code></center>}
          {this.state.domainContainsSlash && <center><FontAwesomeIcon icon={faExclamationTriangle} />&nbsp;&nbsp;Domains must not contain a slash</center>}
          </form>
          {this.state.customDomains.length ? <div className="pk-custom-domain-list">{this.state.customDomains.map(domain =>
            <div key={domain}>{domain}<a onClick={() => this.removeDomain(domain)}className="is-pulled-right"><FontAwesomeIcon icon={faTimes} /></a></div>)}
          </div>
        : <center><p><em>You don't have any custom domains yet.</em></p></center>}
          <div className="pk-domain-help content"><h4>How to add a custom domain</h4>
            <ol>
              <li>Add the domain, including subdomain, above.</li>
              <li>Add a CNAME record in your domain name registrar that points to <code>peek.link</code>. Here are the instructions for <a href="https://www.godaddy.com/help/change-a-cname-record-19237" target="_blank">GoDaddy</a>,
              &nbsp;<a href="https://www.namecheap.com/support/knowledgebase/article.aspx/9646/2237/how-to-create-a-cname-record-for-your-domain" target="_blank">Namecheap</a>,
              and <a href="https://support.dnsimple.com/articles/manage-cname-record/" target="_blank">DNSimple</a>.</li>
              <li>Wait 24-48 hours for your new CNAME record to propagate (it might be done sooner).</li>
            </ol>
          </div>
        </section>
      </div>
    </div>


    <div className={`pk-login modal ${this.state.showLogin && 'is-active'}`}>
    <div className="modal-background" onClick={() => this.setState({ showLogin: false })}></div>
    <div className="modal-card">
      <header className="modal-card-head">
        <p className="modal-card-title">Thank you for your interest!</p>
        <button className="delete" aria-label="close" onClick={() => this.setState({ showLogin: false })}></button>
      </header>
      <section className="modal-card-body content">
        <ul>
            <li>You must sign up or log in to finish creating your new link</li>
            <li>This helps prevent abuse of the service by bad guys</li>
            <li>It also gives you access to a richer experience, including link management and analytics</li>
        </ul>

        <center><button className="button is-large is-primary" onClick={this.props.signUp}>Sign up or log in</button></center>
      </section>
    </div>
  </div>

    </div>
    <Footer showContact={this.props.showContact}/>
    </div>
  }
}

export default DashboardApp
